import { render, staticRenderFns } from "./RouteIcon.vue?vue&type=template&id=07f288cf&scoped=true"
import script from "./RouteIcon.vue?vue&type=script&lang=js"
export * from "./RouteIcon.vue?vue&type=script&lang=js"
import style0 from "./RouteIcon.vue?vue&type=style&index=0&id=07f288cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f288cf",
  null
  
)

export default component.exports